import React from 'react';
import PageHero from '@/components/PageHero';
import SEO from '@/components/SEO';
import { ENDORSEMENTS } from '@/data/content';
import { Quote } from 'lucide-react';

export default function Endorsements() {
  return (
    <div>
      <SEO
        title="Endorsements & Letters"
        description="Endorsement letters from principals, teachers, school resource officers, and students who have experienced the Drug and Alcohol Awareness program."
        path="/endorsements"
      />
      <PageHero
        title="Endorsements & Letters"
        subtitle="Lt. Joe Kress has received countless letters and endorsements for the program. A brief sample follows."
        image="https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1920&q=80"
        crumbs={['Endorsements']}
      />
      <div className="max-w-5xl mx-auto px-4 py-16">
        <div className="space-y-10">
          {ENDORSEMENTS.map((e, i) => (
            <article
              key={i}
              className="grid md:grid-cols-[180px_1fr] gap-6 bg-white p-6 md:p-8 rounded-lg shadow-sm border border-slate-200 hover:shadow-md transition-shadow"
            >
              <div className="flex md:flex-col items-center md:items-start gap-4">
                <img
                  src={e.image}
                  alt={e.name}
                  className="h-24 w-24 md:h-32 md:w-32 rounded-full object-cover border-4 border-amber-100"
                />
                <div>
                  <div className="font-serif font-bold text-[#0b2545]">{e.name}</div>
                  <div className="text-xs text-slate-500 italic mt-1">{e.role}</div>
                </div>
              </div>
              <div>
                <Quote className="h-6 w-6 text-amber-400 mb-3" />
                <div className="space-y-3">
                  {e.body.map((p, j) => (
                    <p key={j} className="text-slate-700 leading-[1.85] text-[15px]">{p}</p>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
